import React from 'react';
import Slider from 'infinite-react-carousel';

import alasan1 from '../images/alasan/1.jpg';
import alasan2 from '../images/alasan/2.jpg';
import alasan3 from '../images/alasan/3.jpg';
import alasan4 from '../images/alasan/4.png';
import alasan5 from '../images/alasan/5.jpg';
import alasan6 from '../images/alasan/6.jpg';

import testimoni1 from '../images/prod/gambar-18.png';
import testimoni2 from '../images/prod/gambar-19.png';

import ptn1 from '../images/ptn/1.png';
import ptn2 from '../images/ptn/2.png';
import ptn3 from '../images/ptn/3.png';
import ptn4 from '../images/ptn/4.png';
import ptn5 from '../images/ptn/5.png';
import ptn6 from '../images/ptn/6.png';
import ptn7 from '../images/ptn/7.png';
import ptn8 from '../images/ptn/8.png';
import ptn9 from '../images/ptn/9.png';
import ptn10 from '../images/ptn/10.png';
import ptn11 from '../images/ptn/11.png';
import ptn12 from '../images/ptn/12.png';

const Content = () => {
  return (
    <section className="text-gray-600 body-font bg-gray-100">
      <div align="center">
      <h1 className='lg:text-5xl md:text-3xl sm:text-2xl text-lg font-black pt-20 lg:max-w-3xl max-w-xs capitalize'>
      6 alasan kenapa kamu yang mau tembus PTN harus sekolah di SMA megana
      </h1>
      </div>
  <div className="container px-5 py-24 mx-auto flex flex-wrap">
    <div className="lg:w-2/3 mx-auto">
      {/* <div className="flex flex-wrap w-full bg-gradient-to-r from-red-400 to-yellow-300 shadow-lg py-32 px-10 relative mb-4"> */}
      {/* <div className="flex flex-wrap w-full bg-white shadow-lg py-32 px-10 relative mb-4">
        <div className="text-center relative z-10 w-full">
          <h2 className="text-2xl text-gray-900 font-medium title-font mb-2 text-indigo-700">Jaminan 100% Lolos Diterima di Perguruan Tinggi Negeri</h2>
          <br />
          <p className="leading-relaxed text-blue-600">SMA Megana mengimplementasikan kurikulum yang mengacu pada standar ujian masuk perguruan tinggi dengan modifikasi dari tim mentor berpengalaman agar para peserta didik mampu beradaptasi dengan semua jenis tes masuk perguruan tinggi negeri seperti Universitas Indonesia, Institut Teknologi Bandung, Universitas Gajah Mada, dan sebagainya</p>
        </div>
      </div> */}
      </div>
      <section className="text-gray-600 body-font">
  <div className="container px-5 py-5 mx-auto">
    {/* <div className="flex flex-col text-center w-full mb-20">
      <h1 className="text-2xl font-medium title-font mb-4 text-gray-900 tracking-widest">OUR TEAM</h1>
      <p className="lg:w-2/3 mx-auto leading-relaxed text-base">Whatever cardigan tote bag tumblr hexagon brooklyn asymmetrical gentrify, subway tile poke farm-to-table. Franzen you probably haven't heard of them.</p>
    </div> */}
    <div className="flex flex-wrap -m-4">
      <div className="p-4 lg:w-1/2">
        <div className="h-full flex sm:flex-row flex-col items-center sm:justify-start justify-center text-center sm:text-left">
          <img alt="team" className="flex-shrink-0 rounded-lg w-48 h-48 object-cover object-center sm:mb-0 mb-4" src={alasan1} />
          <div className="flex-grow sm:pl-8">
            <h2 className="title-font font-medium text-lg text-gray-900 sm:mt-12">1. Jaminan 100% Lolos Diterima di Perguruan Tinggi Negeri</h2>
            {/* <h3 className="text-gray-500 mb-3">UI Developer</h3> */}
            <br />
            <p className="mb-4">SMA Megana mengimplementasikan kurikulum yang mengacu pada standar ujian masuk perguruan tinggi dengan modifikasi dari tim mentor berpengalaman agar para peserta didik mampu beradaptasi dengan semua jenis tes masuk perguruan tinggi negeri.</p>
          </div>
        </div>
      </div>
      <div className="p-4 lg:w-1/2">
        <div className="h-full flex sm:flex-row flex-col items-center sm:justify-start justify-center text-center sm:text-left">
          <img alt="team" className="flex-shrink-0 rounded-lg w-48 h-48 object-cover object-center sm:mb-0 mb-4" src={alasan2} />
          <div className="flex-grow sm:pl-8">
            <h2 className="title-font font-medium text-lg text-gray-900 sm:mt-12">2. Mentor Berpengalaman + Kelas Kecil =  Siswa Fokus</h2>
            {/* <h3 className="text-gray-500 mb-3">Designer</h3> */}
            <br />
            <p className="mb-4">Mentor Megana adalah mentor yang berpengalaman siap membimbing siswa secara small group yakni 1 mentor untuk 5-10 siswa. Hasilnya siswa lebih fokus dan berani mengutarakan pendapat. Karena fokus, siswa tidak perlu lagi mengikuti tambahan bimbel.</p>
          </div>
        </div>
      </div>
      <div className="p-4 lg:w-1/2">
        <div className="h-full flex sm:flex-row flex-col items-center sm:justify-start justify-center text-center sm:text-left">
          <img alt="team" className="flex-shrink-0 rounded-lg w-48 h-48 object-cover object-center sm:mb-0 mb-4" src={alasan3} />
          <div className="flex-grow sm:pl-8">
            <h2 className="title-font font-medium text-lg text-gray-900 sm:mt-12 capitalize">3. Waktu Belajar singkat,  bisa kembangkan minat bakat</h2>
            {/* <h3 className="text-gray-500 mb-3">UI Developer</h3> */}
            <br />
            <p className="mb-4">Siswa Sekolah Megana hanya butuh ¼ waktu dari total waktu belajar di sekolah biasa untuk mendapat Ijazah Kemdikbud. Sehingga ¾ bagian waktu lainnya (±3000 jam) dapat digunakan untuk mencetak prestasi sesuai minat bakat siswa.</p>
          </div>
        </div>
      </div>
      <div className="p-4 lg:w-1/2">
        <div className="h-full flex sm:flex-row flex-col items-center sm:justify-start justify-center text-center sm:text-left">
          <img alt="team" className="flex-shrink-0 rounded-lg w-48 h-48 object-cover object-center sm:mb-0 mb-4" src={alasan4} />
          <div className="flex-grow sm:pl-8">
            <h2 className="title-font font-medium text-lg text-gray-900 sm:mt-12">4. Hemat Biaya, Tetap Tembus Perguruan Tinggi Negeri</h2>
            {/* <h3 className="text-gray-500 mb-3">Designer</h3> */}
            <br />
            <p className="mb-4">Sekolah di Megana School menghemat banyak biaya: biaya gedung (&gt;Rp 20 juta), biaya sekolah biasa (&gt;Rp 15 juta), bimbel (&gt;Rp 5 juta), bimbel intensif PTN (&gt;Rp 20 juta), dan bahkan tidak perlu biaya transportasi siswa karena pembelajaran bisa dilaksanakan dimana saja.</p>
          </div>
        </div>
      </div>
      <div className="p-4 lg:w-1/2">
        <div className="h-full flex sm:flex-row flex-col items-center sm:justify-start justify-center text-center sm:text-left">
          <img alt="team" className="flex-shrink-0 rounded-lg w-48 h-48 object-cover object-center sm:mb-0 mb-4" src={alasan5} />
          <div className="flex-grow sm:pl-8">
            <h2 className="title-font font-medium text-lg text-gray-900 sm:mt-12">5. Kurikulum Efektif</h2>
            {/* <h3 className="text-gray-500 mb-3">Designer</h3> */}
            <br />
            <p className="mb-4">Fokus pada 7 mata pelajaran utama Kurikulum Indonesia: Bahasa Indonesia, Bahasa Inggris, Matematika, PKN, dan Mata Pelajaran Pilihan (Jurusan IPA/IPS). Siswa juga tidak perlu bimbel lagi untuk persiapan Tembus Ujian PTN.</p>
          </div>
        </div>
      </div>
      <div className="p-4 lg:w-1/2">
        <div className="h-full flex sm:flex-row flex-col items-center sm:justify-start justify-center text-center sm:text-left">
          <img alt="team" className="flex-shrink-0 rounded-lg w-48 h-48 object-cover object-center sm:mb-0 mb-4" src={alasan6} />
          <div className="flex-grow sm:pl-8">
            <h2 className="title-font font-medium text-lg text-gray-900 sm:mt-12">6. Sekolah Fokus & Berpengalaman</h2>
            {/* <h3 className="text-gray-500 mb-3">Designer</h3> */}
            <br />
            <p className="mb-4">Sekolah Megana (NPSN: P9947958) adalah satu-satunya sekolah yang fokus menyediakan pendidikan intensif mempersiapkan siswa sejak kelas 1 SMA agar fokus persiapan masuk ke Perguruan Tinggi Negeri impian mereka.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
    
  </div>
  <section className="text-gray-600 body-font bg-white">
  <div className="container px-5 py-24 mx-auto">
      <div className="w-full" align="center">

  <h1 className='lg:text-5xl md:text-3xl sm:text-2xl text-lg font-black mb-14 capitalize'>
  Lulusan sekolah megana telah <br></br>diterima di berbagai PTN
      </h1>
      </div>
  <div className="my-10"></div>
  <Slider className="py-10">
  <div align="center">
        <img src={ptn11} className="w-48 h-48" />      
    </div>
    <div align="center">
        <img src={ptn12} className="w-48 h-48" />      
    </div>
    <div align="center">
    <img src={ptn1} className="w-48 h-48" />
      
    </div>
    <div align="center">
        <img src={ptn2} className="w-48 h-48" />
      
    </div>
    <div align="center">
        <img src={ptn3} className="w-48 h-48" />
      
    </div>
    <div align="center">
        <img src={ptn4} className="w-48 h-48" />
      
    </div>
    <div align="center">
        <img src={ptn5} className="w-48 h-48" />
      
    </div>
    <div align="center">
    <img src={ptn6} className="w-48 h-48" />
      
    </div>
    <div align="center">
        <img src={ptn7} className="w-48 h-48" />
      
    </div>
    <div align="center">
        <img src={ptn8} className="w-48 h-48" />
      
    </div>
    <div align="center">
        <img src={ptn9} className="w-48 h-48" />
    </div>
    <div align="center">
        <img src={ptn10} className="w-48 h-48" />      
    </div>
  </Slider>
  </div>
  </section>
  <section className="text-gray-600 body-font bg-gray-100">
  <div className="container px-5 py-24 mx-auto">
      <div className="w-full" align="center">

  <h1 className='lg:text-5xl md:text-3xl sm:text-2xl text-lg font-black mb-14 capitalize'>
  Testimoni Sekolah Megana
      </h1>
      </div>
  <div className="my-10"></div>
  <Slider className="py-10">
    <div align="center">
    <img src={testimoni1} className="shadow-2xl lg:max-w-screen-lg" />
      
    </div>
    <div align="center">
        <img src={testimoni2} className="shadow-2xl lg:max-w-screen-lg" />
      
    </div>
  </Slider>
  </div>
  </section>
  {/* <div className="flex flex-wrap -mx-2 mb-4">
  <div className="px-2 lg:w-1/2 lg:m-0 m-5">
    <div className="flex flex-wrap w-full bg-gradient-to-r from-yellow-100 to-gray-100 sm:py-24 py-16 sm:px-10 px-6 relative shadow-lg">
      <div className="text-center relative z-10 w-full">
        <h2 className="lg:text-xl text-lg text-gray-900 font-medium title-font mb-2">Pengajar Berpengalaman yang memberikan materi Personalisasi sesuai Kebutuhan peserta didik</h2>
        <br />
        <p className="leading-relaxed">Mentor lulusan PTN yang berpengalaman siap membimbing siswa secara private yakni 1 mentor untuk 1 siswa. Hasilnya siswa lebih fokus, berani mengutarakan pendapat, dan tidak bersaing dengan siswa lain. Karena fokus, siswa tidak perlu lagi mengikuti tambahan bimbel.</p>
      </div>
    </div>
  </div>
  <div className="px-2 lg:w-1/2 lg:m-0 m-5">
    <div className="flex flex-wrap w-full bg-gradient-to-r to-yellow-100 from-gray-100 sm:py-24 py-16 sm:px-10 px-6 relative shadow-lg">
      <div className="text-center relative z-10 w-full">
        <h2 className="lg:text-xl text-lg text-gray-900 font-medium title-font mb-2">Waktu Belajar singkat, bisa kembangkan minat bakat</h2>
        <br />
        <p className="leading-relaxed">Siswa Megana School hanya butuh ¼ waktu dari total waktu belajar di sekolah biasa untuk mendapat Ijazah Kemdikbud. Sehingga ¾ bagian waktu lainnya (±3000 jam) dapat difokuskan untuk pendalaman materi ujian masuk perguruan tinggi serta minat dan bakatnya.</p>
        <br/>
      </div>
    </div>
  </div>
  </div>
  <div className="flex flex-wrap -mx-2">
  <div className="px-2 lg:w-1/2 lg:m-0 m-5">
    <div className="flex flex-wrap w-full bg-gradient-to-r from-yellow-100 to-gray-100 sm:py-24 py-16 sm:px-10 px-6 relative shadow-lg">
      <div className="text-center relative z-10 w-full">
        <h2 className="lg:text-xl text-lg text-gray-900 font-medium title-font mb-2">Menghemat Biaya untuk Masuk PTN Impian!</h2>
        <br />
        <p className="leading-relaxed">Sekolah di Megana School menghemat banyak biaya: biaya gedung, biaya sekolah biasa, bimbel masuk PTN, les bahasa inggris, agen pendidikan sehingga siswa dan orangtua tidak perlu lagi mengeluarkan biaya tambahan.</p>
        <br/><br/><br/>
      </div>
    </div>
  </div>
  <div className="px-2 lg:w-1/2 lg:m-0 m-5">
    <div className="flex flex-wrap w-full bg-gradient-to-r to-yellow-100 from-gray-100 sm:py-24 py-16 sm:px-10 px-6 relative shadow-lg">
      <div className="text-center relative z-10 w-full">
        <h2 className="lg:text-xl text-lg text-gray-900 font-medium title-font mb-2">Sekolah yang sudah berpengalaman &gt;10 tahun menjalankan online learning</h2>
        <br />
        <p className="leading-relaxed">Megana School sudah &gt;10 tahun menjalankan online learning untuk peserta didik di seluruh dunia, Amerika, Tiongkok, dan sebagainya. Megana School sudah dipercaya dan berprestasi sejak tahun 2010, dan telah menerima penghargaan dari Kementerian Pendidikan, Kebudayaan, Riset, dan Teknologi RI.</p>
      </div>
    </div>
  </div>
  </div> */}
</section>



  );
};

export default Content;
